import { PAYMENT_METHODS_TITLES } from 'Jsx/CheckoutV4/common/constants';
import { CustomerExtraData } from 'Jsx/CheckoutV4/hooks/useCustomerExtraData';
import { PaymentMethodType } from 'Jsx/CheckoutV4/types';

import { CardBrandName } from '../../../../../Shared/CardIssuerLogo/CardIssuerLogo';

export const isDLocal = (paymentMethod: PaymentMethodType | undefined) => {
  switch (paymentMethod?.title) {
    case PAYMENT_METHODS_TITLES.DLOCAL_AR:
    case PAYMENT_METHODS_TITLES.DLOCAL_CHILE:
    case PAYMENT_METHODS_TITLES.DLOCAL_COLOMBIA:
    case PAYMENT_METHODS_TITLES.DLOCAL_MEXICO:
    case PAYMENT_METHODS_TITLES.DLOCAL_PERU:
      return true;
    default:
      return false;
  }
};

export const isStripe = (paymentMethod: PaymentMethodType | undefined) => {
  switch (paymentMethod?.title) {
    case PAYMENT_METHODS_TITLES.STRIPE:
    case PAYMENT_METHODS_TITLES.STRIPE_MEXICO:
      return true;
    default:
      return false;
  }
};

export const isStripeMexico = (
  paymentMethod: PaymentMethodType | undefined,
) => {
  switch (paymentMethod?.title) {
    case PAYMENT_METHODS_TITLES.STRIPE_MEXICO:
      return true;
    default:
      return false;
  }
};

export const isEBanx = (paymentMethod: PaymentMethodType | undefined) => {
  switch (paymentMethod?.title) {
    case PAYMENT_METHODS_TITLES.EBANX_CARD:
    case PAYMENT_METHODS_TITLES.EBANX_CARD_AR:
      return true;
    default:
      return false;
  }
};

export const isConekta = (paymentMethod: PaymentMethodType | undefined) => {
  switch (paymentMethod?.title) {
    case PAYMENT_METHODS_TITLES.CONEKTA_CARD:
      return true;
    default:
      return false;
  }
};

export const isPayU = (paymentMethod: PaymentMethodType | undefined) => {
  switch (paymentMethod?.title) {
    case PAYMENT_METHODS_TITLES.PAYU_PERU:
      return true;
    default:
      return false;
  }
};

export const isDLocalOnPaymentMethods = (
  onlinePaymentMethods: PaymentMethodType[] = [],
) => {
  const dLocalMethod = onlinePaymentMethods.find(isDLocal);

  return !!dLocalMethod;
};

export const areDlocalSavedCardsCorrect = ({
  selectedPaymentMethod,
  hasSavedCard,
  customerExtraData,
}: {
  selectedPaymentMethod: PaymentMethodType | undefined;
  hasSavedCard: boolean;
  customerExtraData: CustomerExtraData | undefined;
}): boolean => {
  const isDLocalMethod = isDLocal(selectedPaymentMethod);

  if (!isDLocalMethod) return true;

  const isCustomerExtraDataCorrect: boolean =
    customerExtraData !== undefined &&
    customerExtraData.fullName !== '' &&
    customerExtraData.document !== '';

  return isCustomerExtraDataCorrect && hasSavedCard;
};

const DLOCAL_CARD_BRAND: { [key: string]: CardBrandName } = {
  VI: 'Visa',
  MC: 'MasterCard',
  AE: 'American Express',
  JC: 'JCB',
  DI: 'Discover',
};

export function parseDLocalCardBrand(dlocalBrand: string): CardBrandName {
  return DLOCAL_CARD_BRAND[dlocalBrand] || 'Other';
}
